import laravelLang from '../../../lang/es.json';

export default {
  ...laravelLang,
};
